import {
  Box,
  IconButton,
  styled,
  SvgIcon,
  Toolbar,
  Typography,
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import useClientQuery from "../../../global/queries/useClientQuery";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import ABKLogo from "../../../assets/images/ABK-KP-logo.jpg";
import { ReactComponent as LogOutIcon } from "../../../assets/icons/122 Logout.svg";

const drawerWidth = 240;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

interface IProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const HomeAppBar: React.FC<IProps> = ({ open, setOpen }): JSX.Element => {
  const { data: client } = useClientQuery();
  const reactQueryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <AppBar position="fixed" open={open}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => setOpen(true)}
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
            }}
          >
            <img src={ABKLogo} style={{ maxHeight: 30 }} alt="ABK Logo" />
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => {
              localStorage.removeItem("jwt");
              reactQueryClient.clear();
              navigate("/login");
            }}
          >
            <Typography>Ausloggen</Typography>
            <IconButton
              onClick={() => {
                localStorage.removeItem("jwt");
                reactQueryClient.clear();
                navigate("/login");
              }}
            >
              <SvgIcon
                color={"secondary"}
                component={LogOutIcon}
                inheritViewBox
              />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HomeAppBar;
